/**
 * @jsxRuntime classic
 * @jsx jsx
 */

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx, css } from '@emotion/react';
import { sharedMultiBodiedExtensionStyles } from '@atlaskit/editor-common/ui';
import { fg } from '@atlaskit/platform-feature-flags';
var containerCSS = css({
  minHeight: '100px',
  flexBasis: '100%'
});
var ExtensionFrame = function ExtensionFrame(props) {
  return jsx("div", {
    css: [containerCSS, fg('platform_editor_multi_body_extension_extensibility') &&
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    sharedMultiBodiedExtensionStyles.extensionFrameContent],
    "data-extension-frame": "true"
  }, props.children);
};
export default ExtensionFrame;